import { getTheme, Icon, mergeStyles, Stack, Text } from '@fluentui/react';
import React from 'react';

interface IBwjWarningLabelProps {
    text?: string;
}

export const BwjWarningLabel: React.FunctionComponent<IBwjWarningLabelProps> = (props) => {
    const theme = getTheme();
    const iconStyle = mergeStyles({
        fontSize: theme.fonts.small.fontSize,
        color: theme.semanticColors.severeWarningIcon
    });

  return !!props.text ? (
    <Stack horizontal verticalAlign="center" tokens={{ childrenGap: '5px', padding: '5px' }}>
        <Icon iconName="WarningSolid" className={iconStyle} />
        <Text variant="small">
            {props.text}
        </Text>
    </Stack>
  ) : null;
};
